import { render } from "./VouchersOfSale.vue?vue&type=template&id=e9b96cf4"
import script from "./VouchersOfSale.vue?vue&type=script&lang=js"
export * from "./VouchersOfSale.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__